module.exports = __webpack_public_path__ + "media/images/algolia_logo-7f380839f251da77655f7f56958eec79.png";